import { useMutation } from "react-query";
import { CreateTrainingRequestData } from "@interfaces/request-training";
import requestTrainingService from "@services/request-training-service";

export const useCreateTrainingRequestMutation = () => {
  return useMutation((data: CreateTrainingRequestData) =>
    requestTrainingService.create(data)
  );
};
